import defaultState from 'shared/product_tabs/tab_parts/data/defaultState';
import { getBomCorrectStatus } from 'shared/product_tabs/tab_parts/utils/extracters';
import { IMPORTING, QUOTED, QUOTING_BOM_PARTS } from 'shared/product_tabs/tab_parts/data/BomStatus';

export const clearBom = (state, remove_item) => {
  const {
    id: bom_id,
    line_item_id,
    bom_status,
    saved,
    name, 
    revision,
    board_qtys,
    view,

  } = state;
  const new_bom_status = getBomCorrectStatus(
    bom_status,
    remove_item,
    saved,
  );
  if (remove_item || (bom_status === IMPORTING && !bom_id)) {
    const new_state = _.cloneDeep(defaultState);
    new_state.id = bom_id;
    new_state.name = name;
    new_state.revision = revision;
    new_state.board_qtys = board_qtys;
    new_state.bom_status = new_bom_status;
    new_state.view.zip_file_input_id = view.zip_file_input_id;
    new_state.view.fabrication_slug = view.fabrication_slug;
    new_state.view.bom_selected = false;
    new_state.view.uploaded_zip_file = view.uploaded_zip_file;
    new_state.view.available_bom_in_zip = view.available_bom_in_zip;
    if (new_state.view.uploaded_zip_file && new_state.view.available_bom_in_zip)
      new_state.view.directory = view.directory;
    if (remove_item && line_item_id) {
      new_state.line_item_id = line_item_id;
      new_state.view.destroy = true;
    }

    return { ...new_state };
  }
  state.bom_status = new_bom_status;
  state.view.bom_selected = [QUOTING_BOM_PARTS, QUOTED].includes(
    new_bom_status,
  );
  return null;
};
